
<div :class="dynamicClasses">
  <div class="flex justify-evenly relative">
    <input id="sunday" v-model="content" type="checkbox" class="day-token" value="0" />
    <label for="sunday" class="day-token-label mr-8">
      <DayTokenS />
      <span aria-hidden="true" class="day-token-marker">Sun</span>
      <span class="sr-only">Sunday</span>
    </label>

    <input id="monday" v-model="content" type="checkbox" class="day-token" value="1" />
    <label for="monday" class="day-token-label mr-8">
      <DayTokenM />
      <span aria-hidden="true" class="day-token-marker">Mon</span>
      <span class="sr-only">Monday</span>
    </label>

    <input id="tuesday" v-model="content" type="checkbox" class="day-token" value="2" />
    <label for="tuesday" class="day-token-label mr-8">
      <DayTokenT />
      <span aria-hidden="true" class="day-token-marker">Tue</span>
      <span class="sr-only">Tuesday</span>
    </label>

    <input id="wednesday" v-model="content" type="checkbox" class="day-token" value="3" />
    <label for="wednesday" class="day-token-label mr-8">
      <DayTokenW />
      <span aria-hidden="true" class="day-token-marker">Wed</span>
      <span class="sr-only">Wednesday</span>
    </label>

    <input id="thursday" v-model="content" type="checkbox" class="day-token" value="4" />
    <label for="thursday" class="day-token-label mr-8">
      <DayTokenT />
      <span aria-hidden="true" class="day-token-marker">Thu</span>
      <span class="sr-only">Thursday</span>
    </label>

    <input id="friday" v-model="content" type="checkbox" class="day-token" value="5" />
    <label for="friday" class="day-token-label mr-8">
      <DayTokenF />
      <span aria-hidden="true" class="day-token-marker">Fri</span>
      <span class="sr-only">Friday</span>
    </label>

    <input id="saturday" v-model="content" type="checkbox" class="day-token" value="6" />
    <label for="saturday" class="day-token-label">
      <DayTokenS />
      <span aria-hidden="true" class="day-token-marker">Sat</span>
      <span class="sr-only">Saturday</span>
    </label>
  </div>
  <HelperText v-if="helperText" :text="helperText" :status="status" />
</div>
